import { Table } from 'antd'
import React from 'react'

import { Typography } from '@mui/material'
import { IProductDailyReport } from '../../../../../types/report'
import CircularLoading from '../../../../../components/CircularProgress'
import { numberFormat } from '../../../../../utils'

interface IDailySalesTableProps {
  isLoading?: boolean
  data: IProductDailyReport | undefined
}

const ProductListReportTable = ({ data, isLoading }: IDailySalesTableProps) => {
  const summaryTotal = [
    {
      count: data?.count,
      total: data?.total.length?.toLocaleString(),
      codTotal: data?.total.reduce((acc, cur) => acc + cur.codTotal, 0),
      bankTotal: data?.total.reduce((acc, cur) => acc + cur.bankTotal, 0),
      quantity: data?.total
        .reduce((acc, cur) => acc + cur.quantity, 0)
        ?.toLocaleString(),
    },
  ]

  const columnsTotal = [
    {
      title: 'จำนวนคำสั่งซื้อ (รายการ)',
      dataIndex: 'count',
      key: 'count',
      align: 'center' as 'center',
      width: 150,
      render: (count: number) => (
        <Typography variant="h2" color="text.secondary" textAlign={'center'}>
          {count?.toLocaleString()}
        </Typography>
      ),
    },
    {
      title: 'จำนวนสินค้า (ชนิด)',
      dataIndex: 'total',
      key: 'total',
      align: 'center' as 'center',
      width: 150,
      render: (total: string) => (
        <Typography variant="h2" color="text.secondary" textAlign={'center'}>
          {total?.toLocaleString()}
        </Typography>
      ),
    },
    {
      title: 'จำนวน',
      dataIndex: 'quantity',
      key: 'quantity',
      align: 'center' as 'center',
      width: 150,
      render: (quantity: number) => (
        <Typography variant="h2" color="text.secondary" textAlign={'center'}>
          {quantity?.toLocaleString()}
        </Typography>
      ),
    },
    {
      title: 'COD',
      dataIndex: 'codTotal',
      key: 'codTotal',
      align: 'center' as 'center',
      width: 150,
      render: (codTotal: number) => (
        <Typography variant="h2" color="text.secondary" textAlign={'center'}>
          {numberFormat(codTotal ?? 0, 2)}
        </Typography>
      ),
    },
    {
      title: 'โอน',
      dataIndex: 'bankTotal',
      key: 'bankTotal',
      align: 'center' as 'center',
      width: 150,
      render: (bankTotal: number) => (
        <Typography variant="h2" color="text.secondary" textAlign={'center'}>
          {numberFormat(bankTotal ?? 0, 2)}
        </Typography>
      ),
    },
  ]

  const columns = [
    {
      title: 'ชื่อสินค้า',
      dataIndex: 'productName',
      key: 'productName',
      width: 300,
      render: (productName: string) => {
        return (
          <Typography
            variant="subtitle2"
            color="text.secondary"
            textAlign={'left'}
          >
            {productName}
          </Typography>
        )
      },
    },
    {
      title: 'หมวดหมู่',
      dataIndex: 'categoryName',
      key: 'categoryName',
      width: 200,
      render: (categoryName: number) => (
        <Typography
          variant="subtitle2"
          color="text.secondary"
          textAlign={'left'}
        >
          {categoryName}
        </Typography>
      ),
    },
    {
      title: 'จำนวน',
      dataIndex: 'quantity',
      key: 'quantity',
      align: 'center' as 'center',
      width: 150,
      render: (quantity: number) => (
        <Typography
          variant="subtitle2"
          color="text.secondary"
          textAlign={'center'}
        >
          {quantity?.toLocaleString()}
        </Typography>
      ),
    },
    {
      title: 'COD',
      dataIndex: 'codTotal',
      key: 'codTotal',
      align: 'center' as 'center',
      width: 150,
      render: (codTotal: number) => (
        <Typography
          variant="subtitle2"
          color="text.secondary"
          textAlign={'center'}
        >
          {codTotal?.toLocaleString()}
        </Typography>
      ),
    },
    {
      title: 'โอน',
      dataIndex: 'bankTotal',
      key: 'bankTotal',
      align: 'center' as 'center',
      width: 150,
      render: (bankTotal: number) => (
        <Typography
          variant="subtitle2"
          color="text.secondary"
          textAlign={'center'}
        >
          {bankTotal?.toLocaleString()}
        </Typography>
      ),
    },
  ]

  return (
    <>
      <CircularLoading isLoading={isLoading} />
      <Table
        size={'middle'}
        columns={columnsTotal}
        scroll={{ x: columnsTotal.reduce((pre, cur) => cur.width + pre, 0) }}
        dataSource={summaryTotal.map((data: any, index: number) => {
          return {
            ...data,
            key: index,
          }
        })}
        bordered
        pagination={false}
      />
      {/*<Table*/}
      {/*  loading={isLoading}*/}
      {/*  size={'middle'}*/}
      {/*  columns={columns}*/}
      {/*  scroll={{ x: columns.reduce((pre, cur) => cur.width + pre, 0) }}*/}
      {/*  dataSource={data?.total.map((data: IProductDailyItemsDetailsReport, index: number) => {*/}
      {/*    console.log('data', data)*/}
      {/*    return {*/}
      {/*      ...data,*/}
      {/*      key: index,*/}
      {/*    }*/}
      {/*  })}*/}
      {/*  bordered*/}
      {/*  pagination={false}*/}
      {/*>*/}
      {/*</Table>*/}
    </>
  )
}

export default ProductListReportTable
